import React, { useContext, useEffect } from 'react'
import bannerlogin from "../../Images/bannerlogin.png"
import Chooseplan from './Chooseplan'
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import { Link } from 'react-router-dom';
// import { Helmet } from "react-helmet-async";
import SeoGeneral from '../BusinessPage/SeoGeneral';

const SearchLogin = () => {
    const colordata = useContext(Colorcontext);
    useEffect(() => {
        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);

    const seoMetaData = {
        title: "Neoo Search Business Listing Plans – Basic, Silver & Gold",
        description: "Neoo Search Business Listing plans help you promote your business, post daily updates, connect with clients, and increase enquiries effectively.",
        ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
        ogImageAlt: "NeooSearch Pricing & Plans",
        url: process.env.REACT_APP_APPLICATION_URL + "/business-directory-listing-pricing",
        keywords: "NeooSearch, business listing, pricing plans, Startup account, Enterprise account, business growth, flexible pricing, powerful features",
        type: "website",
        site_name: "NeooSearch",
        canonical: process.env.REACT_APP_APPLICATION_URL + "/business-directory-listing-pricing"
    };
    return (
        <>
            <SeoGeneral data={seoMetaData} />
            <section className='searchloginmain'>
                <div className='cust_container'>
                    <div className='bg-wht'>
                        <div className='bannerloginbg'>
                            <img src={bannerlogin} alt='...' />
                            <div className='bannerloginbgcontent'>
                                <h4 className='busineeheadpara'>Your business directory
                                    for local search</h4>
                                <p className='businesssubparapara'>
                                    List your business in the Neoo Search directory and smartly connect your customers
                                </p>
                                <Link className="freebusinessbtn btn-rth" to="/about-business-directory">
                                    Learn more
                                </Link>
                            </div>
                        </div>
                        <div className=''>
                            <Chooseplan />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SearchLogin
